import { useEffect, useState } from 'react';
import { Typography } from '@material-tailwind/react';
import { FaRegClock } from 'react-icons/fa';

export const CountdownTimer = ({ expiresAt, onExpire }) => {
  const [remainingTime, setRemainingTime] = useState(() => {
    const now = Math.floor(Date.now() / 1000);
    return Math.max(0, expiresAt - now);
  });

  useEffect(() => {
    if (remainingTime <= 0) {
      onExpire();
      return;
    }

    const interval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      const newRemaining = Math.max(0, expiresAt - now);
      setRemainingTime(newRemaining);
      
      if (newRemaining <= 0) {
        clearInterval(interval);
        onExpire();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt, onExpire]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="flex items-center gap-2">
      <FaRegClock className="w-5 h-5 text-blue-600" /> {/* Color usando clase de Tailwind */}
      <Typography 
        variant="h5" 
        className="font-semibold text-blue-600" // Tamaño igual al título
      >
        {formatTime(remainingTime)}
      </Typography>
    </div>
  );
};